import React from 'react';

const ProfileContentHeader = ({
	data,
	extraContent,
}: {
	data: { name: string; isImp?: boolean };
	extraContent?: React.ReactNode;
}) => {
	return (
		<div className="flex gap-3 items-center py-2 px-2 md:px-6 bg-[#FAFAFA] dark:bg-[#18222D] first-of-type:rounded-t-[8px] font-[600] text-[#7777E7] dark:text-[#6698FA] text-sm md:text-base">
			{data.name}
			{data?.isImp ? (
				<div
					// @ts-ignore
					style={{ '--border-width': '2px', '--radius': '5px' }}
					className="media-object isolate py-[1.667px] px-[6.667px] uppercase text-[#1F3343] text-[10px] font-[500] leading-[16.667px] bg-[#fddd48]"
				>
					Important
				</div>
			) : null}
			{extraContent}
		</div>
	);
};

export default ProfileContentHeader;
